import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { UserNote } from 'user/note/user-note';
import { UserNoteVisibility } from 'user/note/user-note-visibiity';

export interface UserNoteDocument {
	readonly id: string;
	readonly creationTimestamp: number;
	readonly note: string;
	readonly targetId: string;
	readonly userId: string;
	readonly visibility: string;
}

export type UserNotesState = EntityState<UserNoteDocument, string>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'userNotes' })
export class UserNotesStore extends EntityStore<UserNotesState> {
	constructor() {
		super();
	}

	public asDocument(userNote: UserNote): UserNoteDocument {
		return userNote
			? {
					id: userNote.id,
					creationTimestamp: userNote.creationTimestamp,
					note: userNote.note,
					targetId: userNote.targetId,
					userId: userNote.userId,
					visibility: userNote.visibility,
			  }
			: null;
	}

	public asEntity(document: UserNoteDocument): UserNote {
		return document
			? new UserNote(
					document.id,
					document.creationTimestamp,
					document.note,
					document.targetId,
					document.userId,
					UserNoteVisibility[document.visibility]
			  )
			: null;
	}
}
